import React from "react";
import styled from "styled-components";
import { animated, useSpring } from "react-spring";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSpinner,
  faWindowMinimize,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import { IChatSettingState } from "../store/chatSetting/types";
import { chatTheme } from "../styles/theme";
import { media } from "../styles/media";

import ChatMessageTree from "./ChatMessageTree";
import ChatBotFreeInput from "./ChatBotFreeInput";
import { sleep } from "./util";

const Chatframe = styled(animated.div)`
  border-radius: ${chatTheme.borderRadius};
  // height: 80%;
  // max-height: 700px;
  height: 100%
  width: 450px;
  max-width: 100vw;
  background: ${chatTheme.colors.background};
  overflow-x: hidden;
  background: #fff;
  box-shadow: 0 0 8px gray;
  position: relative;
  right: 0;
  bottom: 0;
  overflow-y: hidden;
  overscroll-behavior: contain;

  display: flex;
  flex-flow: column;

  @media (max-height: 300px) {
    height: 90vh;
    max-height: 90vh;
  }

  ${media.phone} {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: initial;
    height: 100%;
    border-radius: 0;
  }
`;

const TitleIconContainer = styled.div`
  display: flex;
  align-items: base-line;
  i {
    cursor: pointer;
  }

  ${media.phone} {
    martin-top: 5px;
  }
`;

const ChatMainTitle = styled.div`
  line-height: 1.5;
  overflow: hidden;
  height: 25px;
  padding: 5px 8px 0;
  font-size: 15px;
`;

const ChatTitleMessage = styled.div<{ color: string }>`
  background: ${props => props.color};
  color: #fff;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 35px;

  ${media.phone} {
    height: 30px;
  }
`;

const ChatTitle = styled.div<{ color: string }>`
  background: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold;
  padding: 3px 10px;
  height: 60px;

  overflow: hidden;
`;

const ChatTitleText = styled.div`
  margin: 0 30px;
  color: #fff;
  height: 45px;
  overflow: hidden;
  overscroll-behavior: contain;
  word-break: break-all;
  ${media.phone} {
    // height: 30px;
    height: 40px;
    margin: 0 15px;
    font-size: 14px;
  }
`;

const ChatBotBody = styled(animated.div)`
  overflow-y: scroll;
  overflow-x: hidden;
  // height: 565px;
  flex: 1 1 0%;
  // -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  position: relative;
  z-index: 100;
  // top: 0;
  // bottom: 40px;

  @media (max-height: 813px) {
    flex: 1 1 0%;
  }
`;

const ChatBottomInput = styled.div`
  width: 100%;
  overscroll-behavior: contain;
  background: #fff;
  height: 30px;
  position: relative;
  bottom: 0px;
  border-radius: ${chatTheme.borderRadius};

  ${media.phone} {
    min-height: 50px;
    bottom: 0px;
  }
`;

const ChatBotHeader = styled.div`
  height: 95px;
`;

const CloseIcon = styled(FontAwesomeIcon)<{ id: string; onClick: () => void }>`
  font-size: 12px;
  cursor: pointer;

  ${media.phone} {
    font-size: 22px;
  }
  & path {
    pointer-events: none;
  }
`;

const RemoveIcon = styled(FontAwesomeIcon)<{ onClick: () => void }>`
  cursor: pointer;
  margin-left: 15px;
  ${media.phone} {
    font-size: 24px;
    margin-left: 25px;
  }
`;

interface IProps {
  toggle: boolean;
  setToggle: (toggle: boolean) => void;
  chatSetting: IChatSettingState;
  loading: boolean;
  start: boolean;
  toggleCloseDialog: any;
  toggleChatbot: any;
}

const ChatBotMainFrame: React.FC<IProps> = ({
  toggle,
  setToggle,
  chatSetting,
  loading,
  start,
  toggleCloseDialog,
  toggleChatbot
}) => {
  const dispatch = useDispatch();
  // const [scrollPosition, setScrollPosition] = React.useState(0);
  const chatbotFrameAnim = useSpring({
    from: {
      opacity: toggle ? 0 : 1,
      left: toggle ? "120px" : "0px",
      height: toggle ? "0%" : "100%"
    },
    to: async (next: any, cancel: any) => {
      await next({
        opacity: toggle ? 1 : 0,
        left: toggle ? "0px" : "120px",
        height: toggle ? "100%" : "0%"
      });
    }
    // delay: 100
  });

  // const scroll = useSpring({
  //   from: {
  //     y: 0
  //   },
  //   to: async (next: any, cancel: any) => {
  //     await next(
  //       {
  //         scroll: scrollPosition
  //       }

  //       //   {
  //       //   y: scrollPosition / 1.3
  //       // }
  //     );
  //   },
  //   config: {
  //     mass: 12,
  //     duration: 1260
  //   }
  // });

  // useEffect(() => {
  //   const frameBody = document.querySelector('#chatbot-frame-body');
  //   if (frameBody != null) {
  //     frameBody.scroll({ top: scrollPosition, behavior: 'smooth' });
  //   }
  // }, [scrollPosition]);

  // const measureRef = useCallback(
  //   node => {
  //     if (node !== null) {
  //       console.log('test');
  //       setScrollPosition(node.scrollHeight + 50);
  //     } else {
  //       console.log('else', node);
  //     }
  //   },
  //   [setScrollPosition]
  // );

  const toggleChatbotFrame = async (toggle: boolean) => {
    setToggle(!toggle);
    await sleep(900);
    await toggleChatbot(toggle);
  };

  return (
    <Chatframe
      style={{
        ...chatbotFrameAnim,
        bottom: "0",
        right: "0"
      }}
    >
      {loading === true ? (
        <div
          style={{
            height: "750px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <FontAwesomeIcon icon={faSpinner} pulse size="3x" />
        </div>
      ) : (
        <React.Fragment>
          <ChatBotHeader>
            <ChatTitleMessage color={chatSetting.mainColor}>
              <ChatMainTitle>{chatSetting.mainTitle}</ChatMainTitle>

              <TitleIconContainer>
                <CloseIcon
                  icon={faWindowMinimize}
                  id="chatbot-close-btn" // smoooooth側で制御するためのid
                  onClick={() => toggleChatbotFrame(start)}
                />
                <RemoveIcon icon={faTimes} onClick={toggleCloseDialog} />
              </TitleIconContainer>
            </ChatTitleMessage>

            <ChatTitle color={chatSetting.mainColor}>
              {chatSetting.titleImage !== "" ? (
                <>
                  <img
                    // width={64}
                    height={50}
                    src={chatSetting.titleImage}
                    style={{ marginLeft: `10px` }}
                    alt="チャットボットのタイトル画像"
                  />
                  <ChatTitleText>{chatSetting.title}</ChatTitleText>
                </>
              ) : (
                <ChatTitleText style={{ marginLeft: `10px` }}>
                  {chatSetting.title}
                </ChatTitleText>
              )}
            </ChatTitle>
          </ChatBotHeader>

          <ChatBotBody
            // style={{ ...scroll }}
            id="chatbot-frame-body"
            // ref={measureRef}
          >
            <ChatMessageTree setting={chatSetting} />
            <div id="chat-message-bottom" style={{ height: "1px" }} />
          </ChatBotBody>

          <ChatBottomInput>
            <ChatBotFreeInput
              mainColor={chatSetting.mainColor}
              dispatch={dispatch}
            />
          </ChatBottomInput>
        </React.Fragment>
      )}
    </Chatframe>
  );
};

export default ChatBotMainFrame;
